module.exports = __webpack_public_path__ + "img/BlinkArt_Shield_Basic.62975a39.png";